import { Maybe, Facility } from '@/types/generated';

type VariableMap = { [key: string]: string | undefined };
type FacilityAddress = {
	city?: string | null;
	stateCode?: string | null;
	address1?: string | null;
	zipCode?: string | null;
};

export function resolveContentVariable(template: string, officeInfo: Maybe<Facility>): string {
	const address = (officeInfo as { address?: FacilityAddress } | null | undefined)?.address;
	const city = address?.city ?? '';
	const stateCode = address?.stateCode ?? '';
	const address1 = address?.address1 ?? '';
	const zipCode = address?.zipCode ?? '';
	const schedulingUrl = officeInfo?.scheduling?.schedulingUrl ?? '';

	const variables: VariableMap = {
		facilityName: officeInfo?.name || 'Your Facility',
		brandName: officeInfo?.brand || 'Your Brand',
		facilityCityState: city && stateCode ? `${city}, ${stateCode}` : 'Your Area',
		facilityCity: city || 'Your City',
		facilityState: stateCode || 'Your State',
		facilityCode: officeInfo?.code,
		schedulingUrl: schedulingUrl || '',
		address: address1 ? `${address1}, ${city}, ${stateCode} ${zipCode}` : 'Your Address',
	};

	return Object.keys(variables).reduce((result, key) => {
		if (!result.includes(`[${key}]`)) {
			return result;
		}

		const pat = String.raw`\[${key}\]`;
		const RE = RegExp;

		const variablePattern = new RE(pat, 'g');
		return result.replaceAll(variablePattern, variables[key] ?? '');
	}, template);
}
